<template>
  <div>
    <T1Breadcrumbs class="mb-24" :homeLink="true" :items="getBreadcrumbs()" />
    <h2 class="font-24 font-r">
      {{ geostruct.geotree.Country.name }} - przewodnik turystyczny
    </h2>
    <a-row>
      <a-col>
        <div class="content-pane content-pane_white mb-48">
          <div class="mb-32">
            <ul class="collapsible-list">
              <li
                v-for="region in geostruct.geotree.Country.Region"
                :key="region.locID"
              >
                <div>
                  <span class="arrow-right"></span
                  ><a class="font-m" :href="region.url" :title="region.name">{{
                    region.name
                  }}</a>
                </div>
                <ul class="collapsible-list">
                  <li v-for="mregion in region.Miniregion" :key="mregion.locID">
                    <div>
                      <span
                        :class="{ _open: toggle.indexOf(mregion.locID) >= 0 }"
                        class="arrow-right"
                      ></span>
                      <a :href="mregion.url" :title="mregion.name">{{
                        mregion.name
                      }}</a
                      ><span
                        class="toggle"
                        @click="toggleItem(mregion.locID)"
                        >{{
                          toggle.indexOf(mregion.locID) >= 0 ? "zwiń" : "rozwiń"
                        }}</span
                      >
                    </div>
                    <ul
                      class="collapsible-list active"
                      :class="{ _open: toggle.indexOf(mregion.locID) >= 0 }"
                    >
                      <li
                        v-for="aregion in mregion.Areatown"
                        :key="aregion.locID"
                      >
                        <div>
                          <span class="arrow-right"></span>
                          <a :href="aregion.url" :title="aregion.name">{{
                            aregion.name
                          }}</a>
                        </div>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import * as GEOSTRUCTURE from "../../geotree.js";
import T1Breadcrumbs from "./T1Breadcrumbs/T1Breadcrumbs";

export default {
  name: "przewodnik-turystyczny-content",
  data: () => ({
    geostruct: GEOSTRUCTURE.geostruktura,
    toggle: []
  }),
  methods: {
    getBreadcrumbs() {
      let crumbsArr = [];
      crumbsArr.push({ name: "Przewodnik turystyczny", link: "" });
      return crumbsArr;
    },
    toggleItem: function(key) {
      var i = this.toggle.indexOf(key);
      if (i < 0) {
        this.toggle.push(key);
      } else {
        this.toggle.splice(i, 1);
      }
    }
  },
  mounted() {},
  computed: {},
  components: {
    T1Breadcrumbs
  }
};
</script>

<style lang="scss" scoped>
.collapsible-list {
  list-style-type: none;
  padding: 0;
  margin: 0;

  > li {
    padding: 2px 6px 2px 16px;
    position: relative;

    a {
      color: $text-color-default;

      &:focus,
      &:hover {
        color: $blue-light;
      }
    }
  }

  .toggle {
    color: $blue-light;
    cursor: pointer;
    padding-left: 18px;
  }

  &.active {
    max-height: 0;
    overflow: hidden;
    transition: max-height ease-out 0.15s;
  }

  &._open {
    max-height: 500px;
    transition: max-height ease-in 0.25s;
  }
}
.arrow-right {
  border: solid $gray-40;
  border-width: 0 1px 1px 0;
  display: inline-block;
  padding: 2px;
  position: absolute;
  left: 0;
  top: 10px;
  transform: rotate(-45deg);
  transition: transform linear 0.1s;

  &._open {
    transform: rotate(45deg);
  }
}
</style>
